import React, { useEffect, useState } from "react";
import { IonPage, IonContent, useIonViewWillEnter, IonHeader } from "@ionic/react";
import { useParams, useLocation, Link, useHistory } from "react-router-dom";
import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";
import {
  FormControl,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import { Edit, Delete, People, Business } from "@mui/icons-material";
import { business } from "ionicons/icons";
import styles from "./StaffManagement.module.css";
import { useBusinessContext } from "../../context/business-context";

const StaffManagement1: React.FC = () => {

  const history = useHistory();

  const {
      selectedBusinessId,
      setSelectedBusinessId,
      selectedBusinessTypeId,
      setSelectedBusinessTypeId,
      selectedBusinessName,
      setSelectedBusinessName,
      selectedBusinessTypeName,
      setSelectedBusinessTypeName,
      selectedRoleID,
      setSelectedRoleID,
      selectedRoleName,
    } = useBusinessContext();
  const [staff, setStaff] = useState<any[]>([]);
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [urlIDx, setUrlIDx] = useState("");

  console.log("Params received:", id);

  const fetchStaff = async () => {
    const urlID = location.pathname.split("/").pop(); // Use params if available, else fallback
    setUrlIDx(urlID);
    const form = new FormData();
    form.append("requestID", requestID());
    form.append("business_id", urlID); // Ensure it's a string

    console.log("Form data:", urlIDx);

    try {
      const response = await axios.post(
        baseUrl() + "businesss/getMybusinessStaffList",
        { requestID: requestID(), business_id: urlID },
        config
      );
      console.log(response);
      setStaff(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };



     


  useEffect(() => {
    //fetchElectionData();
    console.log("Window location:", window.location.pathname);
    console.log("Current URL:", location.pathname);

    fetchStaff();
  }, []);
  // Depend on id and pathname

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const data = [
    { name: "Financial Reports", color: "#3498db", link: "/folder/financialReportBranch" },
    { name: "Manage Users", color: "#e74c3c", link: "/folder/manage-staffs" },
    { name: "Wallet Balance", color: "#2ecc71", link: "/folder/wallet" },
    { name: "Setup Ledgers", color: "#9b59b6", link: "/folder/manageLedgerBranch" },
    { name: "Bulk Messaging", color: "#f1c40f", link: "/folder/customers" },
    { name: "Setup Branches", color: "#1abc9c", link: "/folder/branches" },
    { name: "Audit Trail", color: "#34495e", link: "/folder/audit-trail" },
    { name: "Generate Invite Code", color: "#d35400", link: "/folder/invite-code" },
    { name: "Business Settings", color: "#a35409", link: "/folder/business-settings" },
  ];

  return (
    <IonPage className="pageDown">
        <IonHeader style={{ backgroundColor: "white" }}>
              <Box display="flex" justifyContent="space-between" p={2}>
                <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
                {selectedBusinessName && selectedBusinessTypeName && (
                <>
                  {selectedBusinessName} - {selectedBusinessTypeName}
                </>
              )}   
                </Typography>
          
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => history.goBack()}
                  style={{ marginLeft: 10 }}
                >
                  Go Back
                </Button>
              </Box>
            </IonHeader>

      <IonContent>
      {/* <Box className={styles.header}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h4" component="h1" className={styles.title}>
              
              <Business className={styles.titleIcon} />
          {selectedBusinessName && selectedBusinessTypeName && (
                <>
                  {selectedBusinessName} - {selectedBusinessTypeName}
                </>
              )}   
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            
          </motion.div>
        </Box> */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Grid container spacing={2} className="ion-padding">
            {data.map((route, i) => (
              <Grid item xs={12} sm={4} md={4} key={i}>
                <motion.div
                  variants={itemVariants}
                  className={styles.cardWrapper}
                  whileHover={{ y: -5, transition: { duration: 0.2 } }}
                >
                  <Card className={styles.businessCard}>
                    <Box
                      className={styles.cardHeader}
                      sx={{ backgroundColor: route.color }}
                    >
                      <Typography variant="h6" className={styles.businessName}>
                        {route.name}
                      </Typography>
                      <Chip size="small" className={styles.typeChip} />
                    </Box>

                    <Box className={styles.actionButtons}>
                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<People />}
                        size="small"
                        className={styles.staffButton}
                        // style={{ backgroundColor: getBusinessTypeColor(business.business_type_id) }}
                        style={{ backgroundColor: route.color }}

                        // onClick={() => manageStaff(business.business_id)}
                      >
                        <Link to={`${route.link}/${urlIDx}`}>View</Link>
                      </Button>
                    </Box>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </IonContent>
    </IonPage>
  );
};

export default StaffManagement1;
